import React from 'react'
import ClaimItem from './ClaimItem'

class ClaimList extends React.Component {
  constructor(props) {
    super(props)

    this.hasUnumWorkflow = props.claims.reduce((acc, claim) => {
      acc = acc || claim.workflow_unum
      return acc
    }, false)
  }

  renderClaim(claim, index) {
    return (
      <ClaimItem
        key={ index }
        claim={ claim }
      />
    )
  }

  render () {
    return (
      <div>
        <div className='header-div'>
          <h1 className='claim-submission-header'>
            Submit Your Claims
          </h1>
          <p>Each benefit listed below requires additional information to determine your eligibility for a job protected leave of absence and/or any applicable short term disability benefit payment amounts.</p>
          <p className='claim-submission-body-text'>Benefits with a &nbsp;<i className="material-icons blue-icon">cloud_upload</i>&nbsp; can be submitted electronically directly from the LeaveLogic app and will guide you through collection of any additional information required.</p>
          <p className='claim-submission-body-text'>If the benefit is marked with a &nbsp;<i className="material-icons blue-icon">link</i>&nbsp; we will direct you to the online or paper form(s) required and also guide you through the process to submit your request outside of the LeaveLogic app.</p>
          { this.hasUnumWorkflow && <p> Information is refreshed every 15 mins </p> }
        </div>
        {
          this.props.claims.map((claim, index) => this.renderClaim(claim, index))
        }
      </div>
    )
  }
}

export default ClaimList;